import { STEP } from './step.actions';
import { actions, selectors } from '../../state';
import {
  STATES,
  ITEM_DEFINITION_CODES_TO_STATES,
  ITEM_KINDS,
} from '../../constants';
import { getVariation, isFeatureEnabled } from '@updater-core/lib/optimizely';
import { ENVIRONMENT } from '../../environment';
import { SESSION_HEADERS } from '../../constants';
import { graphql } from '../../helpers';
import * as sessionMatchers from '../session/session.matchers';

function deregulatedUtilityEligible(state) {
  const headers = selectors.session.headers(state);
  const query = `query utilityEligibility {
    utilityEligibility {
      deregulatedElectricEligibility {
        eligible
      }
    }
  }`;
  return graphql
    .fetchGraphQLQuery({
      headers,
      query,
      url: `${ENVIRONMENT.endpoints.api.url}/graphql`,
    })
    .then((result) => {
      const eligible =
        result?.data?.utilityEligibility?.deregulatedElectricEligibility
          ?.eligible;
      return eligible;
    });
}

export function StepEpic() {
  return (action, { dispatch, state, getState }) => {
    if (
      sessionMatchers.isCreateSuccess(action) ||
      sessionMatchers.isReadSuccess(action)
    ) {
      // Set the current step if they've refreshed
      const kind = selectors.router.currentDataMoveItemType(state);
      dispatch(actions.step.setCurrent(kind));
    }

    if (action.type === STEP.GO_TO_NEXT) {
      const nextStep = action.payload.nextStep;
      const nextState = Object.keys(ITEM_DEFINITION_CODES_TO_STATES).includes(
        nextStep
      )
        ? ITEM_DEFINITION_CODES_TO_STATES[action.payload.nextStep]
        : nextStep;
      if (nextState === STATES.STEP_PROMOTIONS) {
        return Promise.all([
          isFeatureEnabled('Promotions_Splash_Page_Firehose'),
        ]).then(([enabled]) => {
          dispatch(
            actions.router.stateGo(nextState, {
              showSplashPage: enabled,
            })
          );
        });
      }
      if (nextState === STATES.STEP_UTILITIES) {
        return deregulatedUtilityEligible(getState()).then((eligible) => {
          if (eligible) {
            dispatch(
              actions.router.stateGo(nextState, {
                showIntroBanner: true,
              })
            );
          } else {
            // If the user isn't eligible for deregulated utilities
            // we want to exclude it from the daisy chain.
            // in order to do so we're pretending like we're already on utilities
            // and then going to the step after it.
            dispatch(actions.step.setCurrent(ITEM_KINDS.UTILITY));
            dispatch(
              actions.step.goToNext(selectors.step.nextStep(getState()))
            );
          }
        });
      }
      if (nextState === STATES.STEP_SMART_HOME_OWN) {
        return getVariation('Automate_Your_Home_Step').then((variation) => {
          if (variation === 'variant') {
            dispatch(actions.router.stateGo(nextState));
          } else {
            // If the user isn't in the variant in Automate_Your_Home_Step experience
            // we want to exclude it from the daisy chain.
            // in order to do so we're pretending like we're already on smart-home step
            // and then going to the step after it.
            dispatch(actions.step.setCurrent(ITEM_KINDS.SMART_HOME_OWN));
            dispatch(
              actions.step.goToNext(selectors.step.nextStep(getState()))
            );
          }
        });
      }
      dispatch(
        actions.router.stateGo(nextState, {
          showIntroBanner: true,
        })
      );
    }
  };
}
